import { render, staticRenderFns } from "./app-list.vue?vue&type=template&id=83a027c6&scoped=true&"
import script from "./app-list.vue?vue&type=script&lang=js&"
export * from "./app-list.vue?vue&type=script&lang=js&"
import style0 from "./app-list.vue?vue&type=style&index=0&id=83a027c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a027c6",
  null
  
)

export default component.exports